import { Suspense, lazy } from 'react';

import { Routes, Route } from 'react-router-dom';

import ErrorBoundary from './errors/ErrorBoundary';
import ProtectedRoute from '../routes/ProtectedRoute';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import AccountPlans from './about/accountPlans/AccountPlans';
import LMSPage from '../pages/lms/LMSPage';

import LessonPage from '../pages/lms/LessonPage';
import Introduction from '../pages/lms/Introduction';
import Quiz from '../pages/lms/Quiz';
import WelcomePage from '../pages/lms/WelcomePage';
import { Box } from '@mui/material';
import { margin } from 'polished';

const CourseContentPage = lazy(() => import('../pages/lms/CourseContentPage'));
const MenuPagesList = lazy(() =>
    import('./content/contentLogic/MenuPagesList'),
);
const MenuPageDetail = lazy(() =>
    import('./content/contentLogic/MenuPageDetail'),
);
const SettingPage = lazy(() => import('../pages/settings/SettingPage'));
const AboutPage = lazy(() => import('../pages/about/AboutPage'));
const HelpPage = lazy(() => import('../pages/help/HelpPage'));
const CompanyPage = lazy(() => import('../pages/settings/CompanyPage'));
const HomePageList = lazy(() => import('./content/contentLogic/HomePageList'));
const SuccessPage = lazy(() => import('../pages/payments/SuccessPage'));
const PaymentSuccessPage = lazy(() =>
    import('./profilePage/payment/PaymentSuccessPage'),
);

const Content = ({ siteSetting, isMobile }) => {
    return (
        <Suspense>
            <Box
                sx={{
                    marginTop: {
                        xs: '60px',
                        sm: '90px',
                    },
                    marginBottom: {
                        xs: '140px',
                        sm: '160px',
                    },
                }}
            >
                <Routes>
                    <Route
                        path="/"
                        element={
                            <ErrorBoundary>
                                <ProtectedRoute
                                    element={
                                        <HomePageList
                                            isMobile={isMobile}
                                            siteSetting={siteSetting}
                                        />
                                    }
                                />
                            </ErrorBoundary>
                        }
                    />
                    <Route
                        path="/:menu"
                        element={
                            <ErrorBoundary>
                                <ProtectedRoute element={<MenuPagesList />} />
                            </ErrorBoundary>
                        }
                    />
                    <Route
                        path="/:menu/:slug"
                        element={
                            <ErrorBoundary>
                                <ProtectedRoute element={<MenuPageDetail />} />
                            </ErrorBoundary>
                        }
                    />
                    <Route
                        path="/settings"
                        element={
                            <ErrorBoundary>
                                <ProtectedRoute element={<SettingPage />} />
                            </ErrorBoundary>
                        }
                    />
                    <Route
                        path="settings/organization"
                        element={
                            <ErrorBoundary>
                                <CompanyPage />
                            </ErrorBoundary>
                        }
                    />

                    <Route
                        path="/settings/billing/plans"
                        element={
                            <ErrorBoundary>
                                <AccountPlans />
                            </ErrorBoundary>
                        }
                    />
                    <Route
                        path="/settings/billing/success"
                        element={
                            <ErrorBoundary>
                                <SuccessPage />
                            </ErrorBoundary>
                        }
                    />
                    <Route
                        path="/payment/success"
                        element={
                            <ErrorBoundary>
                                <PaymentSuccessPage />
                            </ErrorBoundary>
                        }
                    />
                    <Route
                        path="/about"
                        element={
                            <ErrorBoundary>
                                <AboutPage />
                            </ErrorBoundary>
                        }
                    />
                    <Route
                        path="/help"
                        element={
                            <ErrorBoundary>
                                <HelpPage />
                            </ErrorBoundary>
                        }
                    />
                    <Route
                        path="/policy"
                        element={
                            <ErrorBoundary>
                                <PrivacyPolicy />
                            </ErrorBoundary>
                        }
                    />
                    <Route
                        path="webinars/lms"
                        element={
                            <ErrorBoundary>
                                <LMSPage />
                            </ErrorBoundary>
                        }
                    />
                    <Route
                        path="/webinars/lms/:courseId"
                        element={
                            <ErrorBoundary>
                                <Suspense>
                                    <CourseContentPage />
                                </Suspense>
                            </ErrorBoundary>
                        }
                    />
                    <Route
                        path="/webinars/lms/:courseId/:lessonId"
                        element={
                            <ErrorBoundary>
                                <LessonPage />
                            </ErrorBoundary>
                        }
                    />
                    <Route
                        path="/webinars/lms/:courseId/introduction"
                        element={
                            <ErrorBoundary>
                                <Introduction />
                            </ErrorBoundary>
                        }
                    />
                    <Route
                        path="/webinars/lms/:courseId/quiz"
                        element={
                            <ErrorBoundary>
                                <Quiz />
                            </ErrorBoundary>
                        }
                    />
                    <Route
                        path="/webinars/lms/:courseId/welcome"
                        element={
                            <ErrorBoundary>
                                <WelcomePage />
                            </ErrorBoundary>
                        }
                    />
                </Routes>
            </Box>
        </Suspense>
    );
};

export default Content;
